<template>
  <div class="grid-x align-middle">
    <span>Helpful?</span>
    <button
      class="helpful-btn padding-right-xxs padding-top-xxs padding-bottom-xxs grid-x align-middle"
      :class="{ 'vote-button': !hasVoted }"
      @click="handleVoteButtonClick"
    >
      <span
        class="medium"
        :class="{ 'selected': hasVoted || willVote }"
      >{{ reviewCount }}</span>
      <span
        class="vote-icon"
        :class="hasVoted || willVote ? 'thumbs-up-selected' : 'thumbs-up'"
      />
      <span class="show-for-sr">Vote as helpful</span>
    </button>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import Toast from '@atomic-ui/toast';
import useVote from '@composables/reviews/useVotes';
import { useProduct } from '@modules/product';
import { trackEvent } from '@utils/bvPixel';

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  totalPositiveFeedbackCount: {
    type: Number,
    required: true,
  },
  isComment: {
    type: Boolean,
    default: false,
  },
});

const { productId } = useProduct();

const { votes, submitCommentVoteFeedback, submitVoteFeedback } = useVote();
const hasVoted = computed(() => Boolean(votes.value[props.id]));
const willVote = ref(false);
// persist totall votes across refresh if votes less 1
const reviewCount = computed(() => {
  const totalFeedback = (props.totalPositiveFeedbackCount || 0);
  const increment = (hasVoted.value || willVote.value ? 1 : 0);
  return totalFeedback + increment;
});

/** total time to wait before submitting vote */
const VOTE_TIMEOUT = 5000;
/** @type {ReturnType<typeof setTimeout>} */
let upvoteTimer;

const cancelVote = () => {
  willVote.value = false;
  clearTimeout(upvoteTimer);
};
const action = computed(() => (props.isComment ? submitCommentVoteFeedback : submitVoteFeedback));

/** Delay sending vote by */
const startVoteTimer = () => {
  willVote.value = true;

  upvoteTimer = setTimeout(async () => {
    try {
      await action.value(props.id, () => {
        Toast({ message: 'Something went wrong. Try again.', placement: 'bottom' });
      });
    } catch (error) {
      console.error(error); // eslint-disable-line
    }
    willVote.value = false;
    // BV track for stats - these run when a thumbs up vote happens on a review
    trackEvent('helpfulness', productId, 'positive');
  }, VOTE_TIMEOUT);
};

function handleVoteButtonClick() {
  if (!hasVoted.value) {
    if (willVote.value) {
      cancelVote();
    } else {
      startVoteTimer();
    }
  }
}
</script>
<style scoped lang="scss">
@import "~settingSCSS";
@import "@csgIcons/_thumbs-up.scss";
@import "@csgIcons/_thumbs-up-selected.scss";

.helpful-btn {
  padding-left: rem-calc(10);
}

.vote-button{
  min-width: rem-calc(57);
  background-color: transparent;
  transition: background-color 0.25s ease-out;
  cursor: pointer;
}

.vote-button:hover{
  background-color: $hover-color;
}

.selected{
  color: $gray-1-color;
}

.vote-icon {
 @include margin-left-xxs;
  transition: margin .25s ease-out;
}

.vote-button:hover .vote-icon{
  margin-left: rem-calc(10) !important;
}

</style>
